


















import { defineComponent, PropType } from "@vue/composition-api"
import ExchangeActionMolecule from "@/apps/StudentExchangeOverviewWidget/components/molecules/ExchangeActionMolecule.vue"
import { ButtonType } from "@/apps/StudentExchangeOverviewWidget/models/shared-viewmodel";

export default defineComponent({
    name: "ExchangeRow",
    components: {
        ExchangeActionMolecule
    },
    props: {
        id: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true,
            default: null
        },
        requestedDate: {
            type: String,
            required: false,
            default: '-'
        },
        status: {
            type: String,
            required: true
        },
        buttonType: {
            type: String as PropType<ButtonType>,
            required: true
        },
        programOfStudyId: {
            type: Number,
            required: true,
        },
        academicYearId: {
            type: String,
            required: true
        }
    }
})
